import { Route, Routes } from "react-router-dom";
import LoginPage from "../pages/auth/login";
import ProtectedRoute from "./protectedRoute.js";
import Categories from "../pages/Categories/index.jsx";
import AddCategoires from "../pages/Categories/addCategoires/index.jsx";
import Inputs from "../pages/Inputs/index.jsx";
import AddInputs from "../pages/Inputs/addInputs/addInputs.jsx";
import EditInputs from "../pages/Inputs/editInputs/editInputs.jsx";
import Packages from "../pages/Packages/index.jsx";
import AddPackages from "../pages/Packages/addPackages/index.jsx";
import EditPackages from "../pages/Packages/editPackages/index.jsx";
import Users from "../pages/users/index.jsx";
import UserDetails from "../pages/users/userDetails/index.jsx";
import Orders from "../pages/Orders/index.jsx";
import Ads from "../pages/Ads/index.jsx";
import AddAds from "../pages/Ads/addAds/index.jsx";
import EditAds from "../pages/Ads/editAds/index.jsx";
import EditCategoires from "../pages/Categories/editCategoires/index.jsx";
import CategoriesBlog from "../pages/categoriesBlog/index.jsx";
import AddCategoiresBlog from "../pages/categoriesBlog/addCategoiresBlog/index.jsx";
import EditCategoiresBlog from "../pages/categoriesBlog/editCategoiresBlog/index.jsx";
import Blogs from "../pages/blogs/index.jsx";
import AddBlogs from "../pages/blogs/addBlogs/index.jsx";
import EditBlogs from "../pages/blogs/editBlogs/index.jsx";
import { Notifications } from "../pages/notifications/index.jsx";
import PaymentMethod from "../pages/paymentMethod/index.jsx";
import Roles from "../pages/roles/index.jsx";
import AddRoles from "../pages/roles/addRoles/index.jsx";
import EditRoles from "../pages/roles/editRoles/index.jsx";
import Permissions from "../pages/permissions/index.jsx";
import ChatPage from "../pages/chat/index.jsx";
import AddNotifications from "../pages/notifications/addNotifications/index.jsx";
import { OutComingNotifications } from "../pages/notifications/outComingNotifications/outComing.jsx";
import Home from "../pages/home/index.jsx";
import Employees from "../pages/employees/index.jsx";
import AddEmployees from "../pages/employees/addEmployees/index.jsx";
import EditEmployees from "../pages/employees/editEmployees/index.jsx";
import Reports from "../pages/reports/index.jsx";
import Pages from "../pages/page/index.jsx";
import PagesSection from "../pages/pageSection/index.jsx";
import AddPagesSection from "../pages/pageSection/addPageSection/index.jsx";
import AddPages from "../pages/page/addPages/index.jsx";
import EditPages from "../pages/page/editPages/index.jsx"
import EditPagesSection from "../pages/pageSection/editPagesSections/index.jsx";
import Banners from "../pages/banners/index.jsx";
import AddBanners from "../pages/banners/addBanners/index.jsx";
import EditBanners from "../pages/banners/editBanners/index.jsx";
import MarketingPromotions from "../pages/marketingPromotions/index.jsx";
import AddMarketingpromotions from "../pages/marketingPromotions/addMarketingPromotions/index.jsx";
import EditMarketingpromotions from "../pages/marketingPromotions/editMaketingPromotions/index.jsx";
import EditApiVersion from "../pages/version/editVersions/index.jsx";
import AddApiVersion from "../pages/version/addVersions/index.jsx";
import ApiVersions from "../pages/version/index.jsx";
import AddUsers from "../pages/users/addUsers/index.jsx";
import EditUsers from "../pages/users/editUsers/index.jsx";
import BoostedAds from "../pages/Ads/boostedAds/index.jsx";
import Badge from "../pages/badge/index.jsx";
import Features from "../pages/feauters/index.jsx";
import AddFeatures from "../pages/feauters/addFeatures/index.jsx";
import EditFeatures from "../pages/feauters/editFeatures/index.jsx";

export default function ApplicationRoutes() {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            {/* <Route path="/deleteMyAccount" element={<DeleteMyaccount />} /> */}
            <Route path="/" element={
                <ProtectedRoute requiredPermission="statistics.view">
                    <Home />
                </ProtectedRoute>}
            />
            <Route path="/home" element={
                <ProtectedRoute requiredPermission="statistics.view">
                    <Home />
                </ProtectedRoute>}
            />
            <Route path="/categories" element={
                <ProtectedRoute requiredPermission="categories.view">
                    <Categories />
                </ProtectedRoute>}
            />
            <Route path="/marketingPromotion" element={
                <ProtectedRoute requiredPermission="marketing_promotions.view">
                    <MarketingPromotions />
                </ProtectedRoute>}
            />
            <Route path="/marketingPromotion/add" element={
                <ProtectedRoute requiredPermission="marketing_promotions.create">
                    <AddMarketingpromotions />
                </ProtectedRoute>}
            />
            <Route path="/marketingPromotion/edit/:marketingPromotionId" element={
                <ProtectedRoute requiredPermission="marketing_promotions.update">
                    <EditMarketingpromotions />
                </ProtectedRoute>}
            />
            <Route path="/banners" element={
                <ProtectedRoute requiredPermission="banners.view">
                    <Banners />
                </ProtectedRoute>}
            />
            <Route path="/banners/add" element={
                <ProtectedRoute requiredPermission="banners.create">
                    <AddBanners />
                </ProtectedRoute>}
            />
            <Route path="/banners/edit/:bannerId" element={
                <ProtectedRoute requiredPermission="banners.update">
                    <EditBanners />
                </ProtectedRoute>}
            />
            <Route path="/reports" element={
                <ProtectedRoute requiredPermission="reports.view">
                    <Reports />
                </ProtectedRoute>}
            />
            <Route path="/pages" element={
                <ProtectedRoute requiredPermission="pages">
                    <Pages />
                </ProtectedRoute>}
            />
            <Route path="/pages/edit/:pageId" element={
                <ProtectedRoute requiredPermission="page">
                    <EditPages />
                </ProtectedRoute>}
            />
            <Route path="/pages/add" element={
                <ProtectedRoute requiredPermission="pages">
                    <AddPages />
                </ProtectedRoute>}
            />
            <Route path="/pageSections" element={
                <ProtectedRoute requiredPermission="pages">
                    <PagesSection />
                </ProtectedRoute>}
            />
            <Route path="/pageSections/edit/:pageSectionId" element={
                <ProtectedRoute requiredPermission="pages">
                    <EditPagesSection />
                </ProtectedRoute>}
            />
            <Route path="/pageSections/add" element={
                <ProtectedRoute requiredPermission="pages">
                    <AddPagesSection />
                </ProtectedRoute>}
            />
            <Route path="/employees" element={
                <ProtectedRoute requiredPermission="employees.view">
                    <Employees />
                </ProtectedRoute>}
            />
            <Route path="/employees/add" element={
                <ProtectedRoute requiredPermission="employees.create">
                    <AddEmployees />
                </ProtectedRoute>}
            />
            <Route path="/inputs" element={
                <ProtectedRoute requiredPermission="inputs.view">
                    <Inputs />
                </ProtectedRoute>}
            />
            <Route path="/versions" element={
                <ProtectedRoute requiredPermission="versions.view">
                    <ApiVersions />
                </ProtectedRoute>}
            />
            <Route path="/versions/add" element={
                <ProtectedRoute requiredPermission="versions.create">
                    <AddApiVersion />
                </ProtectedRoute>}
            />
            <Route path="/versions/edit/:id" element={
                <ProtectedRoute requiredPermission="versions.update">
                    <EditApiVersion />
                </ProtectedRoute>}
            />
            <Route path="/roles" element={
                <ProtectedRoute requiredPermission="roles.view">
                    <Roles />
                </ProtectedRoute>}
            />
            <Route path="/chats" element={
                <ProtectedRoute requiredPermission="support">
                    <ChatPage />
                </ProtectedRoute>}
            />
            <Route path="/roles/add" element={
                <ProtectedRoute requiredPermission="roles.create">
                    <AddRoles />
                </ProtectedRoute>}
            />
            <Route path="/notifications/add" element={
                <ProtectedRoute requiredPermission="notifications.view">
                    <AddNotifications />
                </ProtectedRoute>}
            />
            <Route path="/notifications/outgoing" element={
                <ProtectedRoute requiredPermission="notifications.view">
                    <OutComingNotifications />
                </ProtectedRoute>}
            />
            <Route path="/roles/edit/:roleId" element={
                <ProtectedRoute requiredPermission="roles.update">
                    <EditRoles />
                </ProtectedRoute>}
            />
            <Route path="/employees/edit/:employeeId" element={
                <ProtectedRoute requiredPermission="employees.view">
                    <EditEmployees />
                </ProtectedRoute>}
            />
            <Route path="/roles/edit/permissions/:permissionId" element={
                <ProtectedRoute requiredPermission="roles.update">
                    <Permissions />
                </ProtectedRoute>}
            />
            <Route path="/paymentMethod" element={
                <ProtectedRoute requiredPermission="payments.view">
                    <PaymentMethod />
                </ProtectedRoute>}
            />
            <Route path="/notifications" element={
                <ProtectedRoute requiredPermission="notifications.view">
                    <Notifications />
                </ProtectedRoute>}
            />
            <Route path="/packages" element={
                <ProtectedRoute requiredPermission="packages.view">
                    <Packages />
                </ProtectedRoute>}
            />
            <Route path="/users" element={
                <ProtectedRoute requiredPermission="users.view">
                    <Users />
                </ProtectedRoute>}
            />
            <Route path="/users/add" element={
                <ProtectedRoute requiredPermission="users.view">
                    <AddUsers />
                </ProtectedRoute>}
            />
            <Route path="/users/edit/:userId" element={
                <ProtectedRoute requiredPermission="users.view">
                    <EditUsers />
                </ProtectedRoute>}
            />
            <Route path="/features" element={
                <ProtectedRoute requiredPermission="features.view">
                    <Features />
                </ProtectedRoute>}
            />
            <Route path="/features/add" element={
                <ProtectedRoute requiredPermission="features.view">
                    <AddFeatures />
                </ProtectedRoute>}
            />
            <Route path="/features/edit/:featureId" element={
                <ProtectedRoute requiredPermission="features.view">
                    <EditFeatures />
                </ProtectedRoute>}
            />
            <Route path="/orders" element={
                <ProtectedRoute requiredPermission="orders.view">
                    <Orders />
                </ProtectedRoute>}
            />
            <Route path="/ads" element={
                <ProtectedRoute requiredPermission="ads.view">
                    <Ads />
                </ProtectedRoute>}
            />
            <Route path="/ads/boosted" element={
                <ProtectedRoute requiredPermission="ads.view">
                    <BoostedAds />
                </ProtectedRoute>}
            />
            <Route path="/ads/add" element={
                <ProtectedRoute requiredPermission="ads.create">
                    <AddAds />
                </ProtectedRoute>}
            />
            <Route path="/ads/edit/:adId" element={
                <ProtectedRoute requiredPermission="ads.view">
                    <EditAds />
                </ProtectedRoute>}
            />
            <Route path="/blogs" element={
                <ProtectedRoute requiredPermission="blogs.view">
                    <Blogs />
                </ProtectedRoute>}
            />
            <Route path="/blogs/add" element={
                <ProtectedRoute requiredPermission="blogs.create">
                    <AddBlogs />
                </ProtectedRoute>}
            />
            <Route path="/blogs/edit/:blogId" element={
                <ProtectedRoute requiredPermission="blogs.update">
                    <EditBlogs />
                </ProtectedRoute>}
            />
            <Route path="/categoriesBlog" element={
                <ProtectedRoute requiredPermission="blog_categories.view">
                    <CategoriesBlog />
                </ProtectedRoute>}
            />
            <Route path="/categories/add" element={
                <ProtectedRoute requiredPermission="categories.create">
                    <AddCategoires />
                </ProtectedRoute>}
            />
            <Route path="/blog/categories/add" element={
                <ProtectedRoute requiredPermission="blog_categories.view">
                    <AddCategoiresBlog />
                </ProtectedRoute>}
            />
            <Route path="/blog/categories/edit/:categoryBlogId" element={
                <ProtectedRoute requiredPermission="blog_categories.update">
                    <EditCategoiresBlog />
                </ProtectedRoute>}
            />
            <Route path="/categories/edit/:categoryId" element={
                <ProtectedRoute requiredPermission="categories.update">
                    <EditCategoires />
                </ProtectedRoute>}
            />
            <Route path="/packages/add" element={
                <ProtectedRoute requiredPermission="packages.create">
                    <AddPackages />
                </ProtectedRoute>}
            />
            <Route path="/inputs/add" element={
                <ProtectedRoute requiredPermission="inputs.create">
                    <AddInputs />
                </ProtectedRoute>}
            />
            <Route path="/inputs/edit/:inputId" element={
                <ProtectedRoute requiredPermission="inputs.update">
                    <EditInputs />
                </ProtectedRoute>}
            />
            <Route path="/users/details/:userId" element={
                <ProtectedRoute requiredPermission="users.view">
                    <UserDetails />
                </ProtectedRoute>}
            />
            <Route path="/packages/edit/:packageId" element={
                <ProtectedRoute requiredPermission="packages.update">
                    <EditPackages />
                </ProtectedRoute>}
            />
            <Route path="/badge" element={
                <ProtectedRoute requiredPermission="users.view">
                    <Badge />
                </ProtectedRoute>}
            />
        </Routes>
    );
}